<template>
  <v-app>
    <v-app-bar app>
      <a href="/" class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-4"
          contain
          src="@/assets/logo.svg"
          transition="scale-transition"
          width="35"
        />
        <v-img
          alt="Vuetify Logo"
          class="shrink mt-1"
          contain
          src="@/assets/logo-text.png"
          transition="scale-transition"
          width="70"
        />
      </a>

      <v-spacer></v-spacer>

      <div id="nav">
        <v-btn text href="/services">Hive Services</v-btn>
        <v-btn class="d-none d-md-inline" outlined large @click="scrollTo()"
          >Contact Us</v-btn
        >
        <!-- <v-btn text>
          <v-icon>mdi-account-circle</v-icon>
        </v-btn> -->
      </div>
    </v-app-bar>
    <router-view />

    <!-- <v-content> </v-content> -->
  </v-app>
</template>
<style lang="scss" scoped>
#app {
  padding-top: 70px;
}

#nav {
  margin: auto;
}
</style>
<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
  methods: {
    scrollTo() {
      document.getElementById("applyform").scrollIntoView();
      // this.$refs[ref].scrollIntoView();
      // window.scrollTo(0, document.body.scrollHeight - 500);
    }
  }
};
</script>
